import './home.css';

import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Translate, Storage, translate } from 'react-jhipster';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Alert,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Card,
  Button,
  CardImg,
  CardTitle,
  CardText,
  CardDeck,
  CardSubtitle,
  CardBody,
  CardImgOverlay,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { toast } from 'react-toastify';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import * as moment from 'moment';
import { convertToDisplay } from 'app/shared/util/date-utils';
import { localeToLangKey } from 'app/shared/util/locale-utils';
import { getSession } from 'app/shared/reducers/authentication';
import { getEvents } from 'app/entities/event/event.reducer';

export interface IHomeProp extends StateProps, DispatchProps, RouteComponentProps<{ eventCode: any }> {}

export interface IHomeState {
  animating: boolean;
  activeIndex: number;
  isModalOpen: boolean;
}

const items = [
  {
    src: 'static/images/slider/3.jpg',
    altText: '3',
    caption: ''
  }
];

export class Home extends React.Component<IHomeProp, IHomeState> {
  state: IHomeState = {
    animating: false,
    activeIndex: 0,
    isModalOpen: false
  };

  componentDidMount() {
    const { eventCode } = this.props.match.params;
    if (this.props.eventList.length === 0) this.props.getEvents(eventCode);
    // this.props.getSession(); //TODO: Gil: What is this for?

    // delete transaction if order_token expire
    // const orderToken = Storage.session.get('ORDER_TOKEN');
    // if (orderToken) {
    //   const timeRemaining = orderToken.validUntil - moment().unix() * 1000;
    //   if (timeRemaining <= 0) {
    //     removeAllStorage();
    //   }
    // }
  }

  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.setState({ animating: true });
  }

  onExited() {
    this.setState({ animating: false });
  }

  next() {
    if (this.state.animating) return;
    const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.state.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.state.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  renderPosters() {
    const POSTER_PER_ROW = 3;
    const events = this.props.eventList;
    const numCardDeck = Math.floor(events.length / POSTER_PER_ROW + 1);
    const rows = new Array(numCardDeck);
    for (let i = 0; i < numCardDeck; i++) {
      rows[i] = [];
    }
    let j = 0;

    const onBtnClick = event => {
      const transaction = Storage.session.get('TRANSACTION');
      if (event.sessions && event.sessions.length > 0) {
        if (transaction) {
          // If assigned seat, direct to personal info page
          toast.info(translate('home.reservedseatwarning'));
          this.props.history.push('/order/personal-info');
        } else {
          Storage.session.set('EVENT', event);
          this.props.history.push('/order/date-selection');
        }
      }
    };

    // loop event into rows
    events.map(event => {
      const dates = event.sessions.map(s => moment(s.startTime));
      const from = convertToDisplay(moment.min(dates));
      const to = convertToDisplay(moment.max(dates));
      rows[Math.floor(j / POSTER_PER_ROW)].push(
        <Card key={j++}>
          <div className="container">
            <a onClick={() => onBtnClick(event)}>
              {event.imageUrl ? <img src={event.imageUrl} width="100%" /> : <img src="/poster/default.jpg" width="100%" />}
            </a>
            <div className="bottom">{event['name' + localeToLangKey(this.props.currentLocale)]}</div>
          </div>
          <CardBody className="bg-white">
            {/*<FontAwesomeIcon icon="calendar" className="icon"/>*/}
            <Button color="home" className="float-right" onClick={() => onBtnClick(event)}>
              <Translate contentKey="home.buy">Buy</Translate>
            </Button>
            <span>
              {event.sessions && event.sessions.length === 0 ? (
                ''
              ) : from === to ? (
                <>{from}</>
              ) : (
                <>
                  {from} - <br />
                  {to}
                </>
              )}
            </span>
          </CardBody>
        </Card>
      );
    });

    // fill up empty card
    while (j % POSTER_PER_ROW !== 0) {
      rows[Math.floor(j / POSTER_PER_ROW)].push(<Card key={j++} className="invisible" />);
    }
    return (
      <>
        {rows.map((r, i) => (
          <CardDeck className="mt-4" key={i}>
            {r}
          </CardDeck>
        ))}
      </>
    );
  }

  toggle = () => this.setState({ isModalOpen: !this.state.isModalOpen });

  render() {
    const { eventList } = this.props;
    const { activeIndex } = this.state;

    const slides = items.map(item => (
      <CarouselItem onExiting={this.onExiting} onExited={this.onExited} key={item.altText} className="text-center">
        <img src={item.src} alt={item.altText} width="100%" />
        <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
      </CarouselItem>
    ));

    return (
      <Row className="justify-content-center">
        <Col md="12">
          <Carousel activeIndex={activeIndex} next={this.next} previous={this.previous} className="bg-secondary">
            <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
            {slides}
            {/*<CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
            <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />*/}
          </Carousel>
        </Col>
        <Col md="8" className="mt-3 mb-3">
          {eventList && Array.isArray(eventList) && eventList.length > 0 ? (
            this.renderPosters()
          ) : this.props.errorMessage !== null ? (
            <h1 className="bg-white p-3 text-center">
              <Translate contentKey="home.maint">你正在排隊中，請耐心等候。</Translate>
            </h1>
          ) : (
            <h1 className="p-3 text-center">
              <Translate contentKey="home.busy">你正在排隊中，請耐心等候。</Translate>
            </h1>
          )}
        </Col>
        <Modal isOpen={this.state.isModalOpen} toggle={this.toggle} size="lg">
          <ModalHeader toggle={this.toggle} />
          <ModalBody>
            <br />
            不便之處，敬請見諒。
          </ModalBody>
        </Modal>
      </Row>
    );
  }
}

const mapStateToProps = storeState => ({
  account: storeState.authentication.account,
  isAuthenticated: storeState.authentication.isAuthenticated,
  eventList: storeState.event.entities,
  currentLocale: storeState.locale.currentLocale,
  errorMessage: storeState.event.errorMessage
});

const mapDispatchToProps = {
  getSession,
  getEvents
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Home);
